// Entorno de PRODUCCIÓN
export const environment = {
  production: true,
  // apiUrl: 'http://localhost:2343/api', // Cambiar por tu URL de producción
  // socketUrl: 'http://localhost:2343',
  socketUrl: 'https://traidinglab-35546230649.northamerica-south1.run.app',
  apiUrl: 'https://traidinglab-35546230649.northamerica-south1.run.app/api', // Cambiar por tu URL de producción
  apiVersion: 'v1',
  appName: 'EDU-VWEB',
  ambiente: '0', // 0 = test, 1 = production
  encryptionKey: 'edu-vweb-production-secret-key-2024', // Cambiar por una clave segura en producción
  features: {
    enableAnalytics: true,
    enableErrorTracking: true,
    enableDevTools: false
  },
  firebaseConfig: {
  apiKey: "AIzaSyBuh1jxCsO6NUcIPdOz1_z1Lnc0gRzonJ8",
  authDomain: "traidinglab.firebaseapp.com",
  projectId: "traidinglab",
  storageBucket: "traidinglab.firebasestorage.app",
  messagingSenderId: "250460400956",
  appId: "1:250460400956:web:725bf2baee2019433f0239"
  },
  vapidKey:"BJn7PRfFkCqiAYPvHftiB1VQlFj7braxJnQ01JWNaRQQXO5GV9cONoXdduEAyGH2FY621UDdH9rYf2PZjTy1r14",
  openaiApiKey: '' // Configura tu API key de OpenAI aquí
};

